var ToggleLessMore = $.extend({/* ToggleLessMore */}, BaseComponent, {

	componentSelector: '.toggle-less-more',

	init: function() {
		$(this.componentSelector).each(this.binding.bind(this));
	},

	binding: function(index, element) {
	    var totalItems = $(element).find('.items').children('.item').size();
	    var itemsToShow = 6;

	    $(element).find('.items').children('.item:lt('+itemsToShow+')').show();

	    // SUBITEMS
		$(element).find('.items').children('.item').each(function (item) {

			$(this).find('.subitem').hide();

		});

		$(element).find('.trigger-less-more').find('.more').click((function(event) {

			// Set scroll position to show more button
			if($(event.currentTarget).hasClass('scroll-here')) {
				var scrollPosition = $(event.currentTarget).offset().top;
			}

			if ($(event.currentTarget).parents('.item').length) { // Trigger button is within Item
				$(event.currentTarget).parents('.items').find('.subitem').hide();
				$(event.currentTarget).parents('.item').find('.subitem').show();

				$(event.currentTarget).parents('.items').find('.item').removeClass('active');
				$(event.currentTarget).parents('.item').addClass('active');

				$(event.currentTarget).parents('.items').find('.item').find('.trigger-less-more').find('.less').removeClass('active');
				$(event.currentTarget).parents('.items').find('.item').find('.trigger-less-more').find('.more').addClass('active');

				$(event.currentTarget).removeClass('active');
				$(event.currentTarget).parents('.trigger-less-more').find('.less').addClass('active');

				Utils.scrollTo((typeof scrollPosition == 'undefined') ? $(event.currentTarget).parents('.item').offset().top : scrollPosition);
			}
			else {
		        $(event.currentTarget).parents('.toggle-less-more').find('.items').children('.item:lt('+totalItems+')').show();

		        // SUBITEMS
		        $(event.currentTarget).parents('.toggle-less-more').find('.items').children('.item').children('.subitem').hide();

		        $(event.currentTarget).parents('.toggle-less-more').find('.items').children('.item').removeClass('active');
		        $(event.currentTarget).parents('.toggle-less-more').find('.items').children('.item').find('.trigger-less-more').find('.less').removeClass('active');
		        $(event.currentTarget).parents('.toggle-less-more').find('.items').children('.item').find('.trigger-less-more').find('.more').addClass('active');

		        $(event.currentTarget).parents('.toggle-less-more').find('.items').children('.item').find('.less').removeClass('active');
		        $(event.currentTarget).parents('.toggle-less-more').find('.items').children('.item').find('.more').addClass('active');

		        $(event.currentTarget).removeClass('active');
		        $(event.currentTarget).parents('.trigger-less-more').find('.less').addClass('active');

		        Utils.scrollTo((typeof scrollPosition == 'undefined') ? $('.tabs-component').offset().top : scrollPosition);
			}


		}).bind(this));

		$(element).find('.trigger-less-more').find('.less').click((function(event) {

			if ($(event.currentTarget).parents('.item').length) { // Trigger button is within Item
				$(event.currentTarget).parents('.items').find('.subitem').hide();
				$(event.currentTarget).parents('.item').find('.subitem').hide();

				$(event.currentTarget).parents('.item').removeClass('active');

				$(event.currentTarget).parents('.items').find('.item').find('.trigger-less-more').find('.less').removeClass('active');
				$(event.currentTarget).parents('.items').find('.item').find('.trigger-less-more').find('.more').addClass('active');

				$(event.currentTarget).removeClass('active');
				$(event.currentTarget).parents('.trigger-less-more').find('.more').addClass('active');

				Utils.scrollTo($(event.currentTarget).parents('.item').offset().top);
			}
			else {
		        $(event.currentTarget).parents('.toggle-less-more').find('.items').children('.item').not(':lt('+itemsToShow+')').hide();

		        // SUBITEMS
		        $(event.currentTarget).parents('.toggle-less-more').find('.items').children('.item').children('.subitem').hide();

		        $(event.currentTarget).parents('.toggle-less-more').find('.items').children('.item').removeClass('active');
		        $(event.currentTarget).parents('.toggle-less-more').find('.items').children('.item').find('.trigger-less-more').find('.less').removeClass('active');
		        $(event.currentTarget).parents('.toggle-less-more').find('.items').children('.item').find('.trigger-less-more').find('.more').addClass('active');

		        $(event.currentTarget).parents('.toggle-less-more').find('.items').children('.item').find('.less').removeClass('active');
		        $(event.currentTarget).parents('.toggle-less-more').find('.items').children('.item').find('.more').addClass('active');

		        $(event.currentTarget).removeClass('active');
		        $(event.currentTarget).parents('.trigger-less-more').find('.more').addClass('active');

		        Utils.scrollTo($('.tabs-component').offset().top);
	       	}


		}).bind(this));
	},

})
